module.exports = __webpack_public_path__ + "img/grid-alignment.56eec7e1.png";